<template>
  <div class="msc-ag-actions">
    <v-menu
      offset-y
      left
      open-on-hover
      :close-on-content-click="true"
      :nudge-left="4"
      content-class="msc-actions-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          x-small
          class="msc-ag-actions-trigger"
          v-bind="attrs"
          v-on="on"
          @click.stop
        >
          <v-icon small>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense class="py-0">
        <v-list-item
          :disabled="isSaving"
          @click.stop="saveRow"
        >
          <v-list-item-title class="d-flex align-center">
            <v-progress-circular
              v-if="isSaving"
              indeterminate
              size="14"
              width="2"
              class="mr-2"
            />
            Save
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="showMarkBilled"
          :disabled="isCompleting"
          @click.stop="markBilled"
        >
          <v-list-item-title class="d-flex align-center">
            <v-progress-circular
              v-if="isCompleting"
              indeterminate
              size="14"
              width="2"
              class="mr-2"
            />
            Mark As Billed
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'MscReportActionsCell',
  computed: {
    parent() {
      return this.params && this.params.context && this.params.context.componentParent;
    },
    row() {
      return this.params && this.params.data;
    },
    isSaving() {
      return this.parent && this.parent.isRowSaving(this.row);
    },
    isCompleting() {
      return this.parent && this.parent.isRowCompleting(this.row);
    },
    showMarkBilled() {
      return this.parent && this.parent.canShowMarkAsBilled(this.row);
    },
  },
  methods: {
    refresh() {
      return true;
    },
    saveRow() {
      if (this.parent && this.row && !this.isSaving) {
        this.parent.saveMscInlineRow(this.row);
      }
    },
    markBilled() {
      if (this.parent && this.row && !this.isCompleting) {
        this.parent.markJobComplete(this.row);
      }
    },
  },
};
</script>

<style scoped>
.msc-ag-actions {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: visible;
}
</style>
